"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _sort = require("../../utilities/sort");
var _SvgIcon = require("../icons/SvgIcon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var DataTable = /*#__PURE__*/function (_React$Component) {
  _inherits(DataTable, _React$Component);
  var _super = _createSuper(DataTable);
  function DataTable(props) {
    var _this;
    _classCallCheck(this, DataTable);
    _this = _super.call(this, props);
    _this.tableRef = /*#__PURE__*/_react["default"].createRef();
    _this.tableContainerRef = /*#__PURE__*/_react["default"].createRef();
    _this.fixedHeaderTableRef = /*#__PURE__*/_react["default"].createRef();
    _this.onWindowResize = _this.onWindowResize.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(DataTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.fixedTableHeader) {
        window.addEventListener("resize", this.onWindowResize);
        this.adjustFixedTableDimensions();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.fixedTableHeader) {
        window.removeEventListener("resize", this.onWindowResize);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.fixedTableHeader) {
        this.adjustFixedTableDimensions();
      }
    }
  }, {
    key: "onWindowResize",
    value: function onWindowResize() {
      if (this.props.fixedTableHeader) {
        this.adjustFixedTableDimensions();
      }
    }
  }, {
    key: "getObjectPathValue",
    value: function getObjectPathValue(obj, path) {
      var arr = path.split('.');
      while (arr.length) {
        var propName = arr.shift();
        if (obj[propName] !== undefined) {
          obj = obj[propName];
        } else {
          obj = '';
          break;
        }
      }
      return obj;
    }
  }, {
    key: "renderTableHeaderRow",
    value: function renderTableHeaderRow(columnConfig, onColumnSort, columnSortDirection, columnSortField, fixedTableHeader) {
      return /*#__PURE__*/_react["default"].createElement("tr", null, columnConfig.map(function (column, index) {
        var thStyle = column.thStyle || {};
        if (fixedTableHeader) {
          thStyle.width = column.width;
        }
        if (column.sortField) {
          var sortIcon = /*#__PURE__*/_react["default"].createElement(_SvgIcon.SvgSortDefault, {
            className: "svg-sort-default"
          });
          if (columnSortDirection === _sort.SORT_DIRECTION.Ascending && columnSortField === column.sortField) {
            sortIcon = /*#__PURE__*/_react["default"].createElement(_SvgIcon.SvgArrowUp, null);
          }
          if (columnSortDirection === _sort.SORT_DIRECTION.Descending && columnSortField === column.sortField) {
            sortIcon = /*#__PURE__*/_react["default"].createElement(_SvgIcon.SvgArrowDown, null);
          }
          if (!onColumnSort) {
            // eslint-disable-next-line no-console
            console.error(["\n\nDEVELOPER ERROR: You configured column sortField", column.sortField, "in your columns configuration", "but forgot to set the onColumnSort function to handle the column header sort click.", "\n\nAdd the onColumnSort prop to your <DataTable> or <SelectedItemsSummary> to fix this issue.\n\n"].join(' '));
          }
          return /*#__PURE__*/_react["default"].createElement("th", {
            key: "th" + index,
            className: column.thClassName,
            style: thStyle
          }, /*#__PURE__*/_react["default"].createElement("button", {
            onClick: function onClick() {
              return onColumnSort(column.sortField);
            },
            className: "th-sort-button"
          }, /*#__PURE__*/_react["default"].createElement("span", null, column.headerName), sortIcon));
        }
        return /*#__PURE__*/_react["default"].createElement("th", {
          key: "th" + index,
          className: column.thClassName,
          style: thStyle
        }, column.headerName || "");
      }));
    }
  }, {
    key: "createComponent",
    value: function createComponent(componentDefinition, row, componentKey) {
      var _this2 = this;
      var component = componentDefinition.component,
        eventHandlerParameters = componentDefinition.eventHandlerParameters,
        mapFieldsToProps = componentDefinition.mapFieldsToProps;
      if (component && /*#__PURE__*/_react["default"].isValidElement(component)) {
        var componentProps = {};
        if (eventHandlerParameters) {
          Object.entries(eventHandlerParameters).forEach(function (entry) {
            var eventName = entry[0];
            var parameterFieldNames = entry[1];
            var parameters = parameterFieldNames.map(function (fieldName) {
              return _this2.getObjectPathValue(row, fieldName);
            });
            componentProps[eventName] = function () {
              component.props[eventName].apply(null, parameters);
            };
          });
        }
        if (mapFieldsToProps) {
          Object.entries(mapFieldsToProps).forEach(function (entry) {
            var propName = entry[0];
            var fieldName = entry[1];
            var propValue = _this2.getObjectPathValue(row, fieldName);
            componentProps[propName] = propValue;
          });
        }
        componentProps.key = componentKey;
        return /*#__PURE__*/_react["default"].cloneElement(component, componentProps);
      }
    }
  }, {
    key: "getTdContent",
    value: function getTdContent(row, columnConfig, columnIndex) {
      var _this3 = this;
      if (columnConfig.field) {
        return this.getObjectPathValue(row, columnConfig.field);
      }
      if (columnConfig.render) {
        return columnConfig.render.map(function (componentDefinition, componentIndex) {
          var componentKey = "col" + columnIndex + "-component-" + componentIndex;
          return _this3.createComponent(componentDefinition, row, componentKey);
        });
      }
      return '';
    }
  }, {
    key: "renderTableDataCell",
    value: function renderTableDataCell(row, columnConfig, fixedTableHeader) {
      var _this4 = this;
      return columnConfig.map(function (column, columnIndex) {
        var tdContent = _this4.getTdContent(row, column, columnIndex);
        var tdClassName = column.tdClassName || undefined;
        var tdStyle = column.tdStyle || {};
        if (fixedTableHeader) {
          tdStyle.width = column.width;
        }
        return /*#__PURE__*/_react["default"].createElement("td", {
          className: tdClassName,
          key: "td" + columnIndex,
          style: tdStyle
        }, tdContent);
      });
    }
  }, {
    key: "renderTableRows",
    value: function renderTableRows(data, columnConfig) {
      var _this5 = this;
      return data.map(function (row, index) {
        return /*#__PURE__*/_react["default"].createElement("tr", {
          className: row.trClassName ? row.trClassName : undefined,
          key: "dataRow" + index
        }, _this5.renderTableDataCell(row, columnConfig));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        data = _this$props.data,
        columns = _this$props.columns,
        className = _this$props.className,
        style = _this$props.style,
        onColumnSort = _this$props.onColumnSort,
        columnSortDirection = _this$props.columnSortDirection,
        columnSortField = _this$props.columnSortField,
        fixedTableHeader = _this$props.fixedTableHeader,
        condensed = _this$props.condensed;
      if (data && data.length > 0) {
        var cssClasses = ["data-table"];
        if (className) {
          cssClasses.push(className);
        }
        if (condensed) {
          cssClasses.push("condensed");
        }
        if (fixedTableHeader) {
          cssClasses.push("table-layout-fixed");
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "data-table-scrollbar-container",
          ref: this.tableContainerRef
        }, fixedTableHeader && /*#__PURE__*/_react["default"].createElement("table", {
          className: cssClasses.join(" ") + " position-fixed",
          ref: this.fixedHeaderTableRef,
          style: {
            zIndex: "2"
          }
        }, /*#__PURE__*/_react["default"].createElement("thead", null, this.renderTableHeaderRow(columns, onColumnSort, columnSortDirection, columnSortField, fixedTableHeader))), /*#__PURE__*/_react["default"].createElement("table", {
          className: cssClasses.join(" "),
          style: style,
          ref: this.tableRef
        }, /*#__PURE__*/_react["default"].createElement("thead", {
          style: fixedTableHeader ? {
            visibility: "hidden"
          } : null
        }, this.renderTableHeaderRow(columns, onColumnSort, columnSortDirection, columnSortField, fixedTableHeader)), /*#__PURE__*/_react["default"].createElement("tbody", null, this.renderTableRows(data, columns, fixedTableHeader))));
      }
      return null;
    }
  }, {
    key: "adjustFixedTableDimensions",
    value: function adjustFixedTableDimensions() {
      var _this6 = this;
      if (this.tableContainerRef.current && this.fixedHeaderTableRef.current && this.tableRef.current) {
        var tableContainerBoundaryRect = this.tableContainerRef.current.getBoundingClientRect();
        var tableBoundaryRect = this.tableRef.current.getBoundingClientRect();
        var tableContentHeight = tableBoundaryRect.height;
        var calculatedTableContainerHeight = window.innerHeight - tableContainerBoundaryRect.top - (this.props.tableContainerBottomOffset || 24);
        if (tableContentHeight < calculatedTableContainerHeight) {
          this.tableContainerRef.current.style.height = 'auto';
        } else {
          this.tableContainerRef.current.style.height = calculatedTableContainerHeight + 'px';
          this.tableContainerRef.current.style.borderBottom = "1px solid #d3e1e8";
        }
        window.setTimeout(function () {
          if (_this6.fixedHeaderTableRef.current && _this6.tableRef.current) {
            _this6.fixedHeaderTableRef.current.style.width = _this6.tableRef.current.getBoundingClientRect().width + 'px';
          }
        }, 10);
      }
    }
  }]);
  return DataTable;
}(_react["default"].Component);
DataTable.propTypes = {
  data: _propTypes["default"].array.isRequired,
  columns: _propTypes["default"].array.isRequired,
  onColumnSort: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  columnSortDirection: _propTypes["default"].string,
  columnSortField: _propTypes["default"].string,
  fixedTableHeader: _propTypes["default"].bool,
  condensed: _propTypes["default"].bool,
  tableContainerBottomOffset: _propTypes["default"].number
};
var _default = DataTable;
exports["default"] = _default;